import  { AxiosResponse, AxiosResponseHeaders, AxiosError } from "axios"
import axios  from "./index"
import { User, AuthHeaders } from "../stores/store_types"

const callSignInApi = (params:  { email:string, password:string }, successCallback: (headers: AxiosResponseHeaders, data: User) => void, failureCallback: () => void) => {
  axios.post("/api/v1/auth/sign_in", {
    email: params.email,
    password: params.password
  }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data.data)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const callValidateTokenApi = (headers: AuthHeaders, successCallback: (headers: AxiosResponseHeaders, result: boolean) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/auth/validate_token",
    { headers: headers }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data.success)
  }).catch((error: AxiosError) => {
    failureCallback()
  })
}

const callSignOutApi = (headers: AuthHeaders, successCallback: (headers: AxiosResponseHeaders, result: boolean) => void, failureCallback: () => void) => {
  axios.delete(
    "/api/v1/auth/sign_out",
    { headers: headers }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data.success)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

export { callSignInApi, callSignOutApi, callValidateTokenApi}
